import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ActionButtonService {
  private readonly openedMenuId = signal<string | null>(null);

  open(id: string): void {
    this.openedMenuId.set(id);
  }

  close(): void {
    this.openedMenuId.set(null);
  }

  toggle(id: string): void {
    this.openedMenuId.update((current) => (current === id ? null : id));
  }

  isOpen(id: string): boolean {
    return this.openedMenuId() === id;
  }
}
